import {
  createAxiosLogistica,
  createAxiosHeadersLogistica,
} from "./axiosHttpMarconi";

export const stockService = {
  getStock,
  getExcel,
};

function getStock(pagination, filters) {
  const axios = createAxiosLogistica();
  let urlPath = `logistica/stock`;
  const params = new URLSearchParams({ ...pagination, ...filters });

  urlPath += `?${params.toString()}`;
  return axios.get(urlPath);
}

function getExcel(filters) {
  const axios = createAxiosHeadersLogistica();
  let urlPath = `logistica/stock/excel`;
  const params = new URLSearchParams(filters);

  urlPath += `?${params.toString()}`;
  return axios.get(urlPath, { responseType: "blob" }).then((response) => {
    const contentDisposition = response.headers["content-disposition"];
    const fileName = contentDisposition;
    return Promise.resolve({ blob: response.data, fileName: fileName });
  });
}
